export default __webpack_public_path__ + "static/media/mailicon.95c3dd9d.png";